import { render, staticRenderFns } from "./rateDialog.vue?vue&type=template&id=971db6ca&scoped=true&"
import script from "./rateDialog.vue?vue&type=script&lang=js&"
export * from "./rateDialog.vue?vue&type=script&lang=js&"
import style0 from "./rateDialog.vue?vue&type=style&index=0&id=971db6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971db6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('971db6ca')) {
      api.createRecord('971db6ca', component.options)
    } else {
      api.reload('971db6ca', component.options)
    }
    module.hot.accept("./rateDialog.vue?vue&type=template&id=971db6ca&scoped=true&", function () {
      api.rerender('971db6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/category/rateDialog.vue"
export default component.exports